import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, EventEmitter, computed, inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

import { SelfServiceCommandKeys } from "../../../helpers/enums/selfServiceCommands";
import { StartLoadMessage } from "../../../helpers/self-service/models/types";
import { ResendConfirmation } from "../../../helpers/self-service/resend_confirmation";
import { SelfserviceWizard } from "../../selfservice/selfservice-wizard/selfservice-wizard";

@Component({
  selector: "dialog-send-config",
  templateUrl: "dialog-send-config.html",
  styleUrls: ["dialog-send-config.scss", "../../selfservice/selfservice-loader/selfservice-loader.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AngularSvgIconModule, TranslatePipe, FormsModule, SelfserviceWizard],
})
export class DialogSendConfig {
  private data = inject<{ subscriptionId: string }>(MAT_DIALOG_DATA);
  private readonly dialogRef = inject(MatDialogRef<DialogSendConfig>);
  private subscriptionId = computed(() => this.data.subscriptionId);

  protected readonly bus = new EventEmitter<StartLoadMessage>();

  protected persons = [{ name: "", email: "", valid: false }];

  protected get allValid() {
    return this.persons.every((e) => e.valid);
  }

  protected closeDialog() {
    this.dialogRef.close();
  }

  protected verify(index: number, event: Event) {
    this.persons[index].valid = (event.target as HTMLInputElement).classList.contains("ng-valid");
  }

  protected paste(index: number, event: Event) {
    setTimeout(() => this.verify(index, event), 300);
  }

  protected addRow() {
    this.persons.push({ name: "", email: "", valid: false });
  }

  protected removeRow(i: number) {
    this.persons.splice(i, 1);
  }

  protected readonly buildCommand = () => {
    const command = new ResendConfirmation(this.subscriptionId(), SelfServiceCommandKeys.ResendConfirmation);
    this.persons.forEach((p) => command.addPerson({ fullName: p.name, email: p.email }));
    return { command, action: SelfServiceCommandKeys.ResendConfirmation };
  };
}
